import { render, staticRenderFns } from "./SelectionsStatCard.vue?vue&type=template&id=ae4409d6&scoped=true&"
import script from "./SelectionsStatCard.vue?vue&type=script&lang=js&"
export * from "./SelectionsStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4409d6",
  null
  
)

export default component.exports